import React, { createContext, useContext } from "react";
import { useAuthService } from "../services/Auth.service";

let operationsAllowed: any = {};
const AuthFacadeContext = createContext(operationsAllowed);

export const AuthFacadeProvider = (props: any) => {

  const authService = useAuthService();

  const login = (credentials: any) => {
    authService.login(credentials);
  }

  const logout = () => {
    authService.logout();
  }
  
  const createOrganization = (organization: any) => {
    return authService.createOrganization(organization);
  }


  operationsAllowed = {
    login,
    logout,
    createOrganization
  }

  return (
    <AuthFacadeContext.Provider value={operationsAllowed}>
      {props.children}
    </AuthFacadeContext.Provider>
  );
}

export const useAuthFacade = () => {
  return useContext(AuthFacadeContext);
}